<template>
  <Header>
    <template #menu-main>
      <div class="Menu__main">
        <li class="Menu__item">
          <a href="/" class="Menu__link">{{ $t("VUE.MAIN_PAGE") }}</a>
        </li>
      </div>
    </template>

    <template #socials>
      <Socials />
    </template>

    <template #share>
      <Share wrapper="Nav" :icons="share.icons" />
    </template>

    <template #helpForm>
      <RequestFormButton
        v-intro-autostart="true"
        v-intro-autostart.config="{
          doneLabel: 'Готово',
          prevLabel: '←',
          nextLabel: '→',
          skipLabel: '×'
        }"
        v-intro="$t('HINTS.PROJECT_HINT_STEP_1')"
        v-intro-step="1"
        v-intro-autostart:on.complete="onComplete"
        v-intro-autostart:on.exit="onComplete"
        v-intro-if="hints('project') && $route.path.length === 4"
      />
    </template>
  </Header>
</template>

<script>
import { Header } from "@/components";
import { Socials, Share, RequestFormButton } from "@/components/app";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SecondHeader",
  computed: {
    ...mapGetters(["share", "hints"])
  },
  methods: {
    ...mapMutations(["managePopupState", "manageHints"]),
    onComplete() {
      this.manageHints({ show: false, hints: "project_hints" });
    }
  },
  components: {
    Header,
    Socials,
    Share,
    RequestFormButton
  }
};
</script>
